import config from "../../config";
import types from "./actionsTypes";
import Auth from "../auth/actions";
import { batch } from "react-redux";
const log = console.log;

export const getRecentHistory = () => async (dispatch) => {

	const myHeaders = new Headers();

	myHeaders.append("Content-Type", "application/json");
	myHeaders.append("Authorization", Auth.authHeader());

	const requestOptions = {
		method: "GET",
		headers: myHeaders,
	};

	return fetch(config.apiUrl + "history", requestOptions)
		.then((response) => response.json())
		.then((result) => {
			batch(() => {
				dispatch({ type: types.SET_HISTORY, payload: result.data });
			});
		})
		.catch((error) => log("error", error));
};
